import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HeaderBar.css';
import ChampionSearch from '../../LandingPage/ChampionSearch';

interface HeaderBarProps {
  showSearch?: boolean;
  showDamageCalculatorButton?: boolean;
}

const HeaderBar: React.FC<HeaderBarProps> = ({ 
  showSearch = true, 
  showDamageCalculatorButton = true 
}) => {
  const navigate = useNavigate();
  const handleLogoClick = () => {
    navigate('/');
  };

  const handleChampionSelect = (championName: string) => {
    if (championName.trim() === '') {
      alert('Please enter a champion name');
      return;
    }
    navigate(`/champions/${championName}`);
  };

  return (
    <div className="header-bar">
      <div className="header-left">
        <img 
          src="/logov6.png" 
          alt="LoL Calculator" 
          className="header-logo"
          onClick={handleLogoClick}
        />
        <h1 className="header-title" onClick={handleLogoClick}>
          LoL Calculator
        </h1>
      </div>

      {showSearch && (
        <div className="header-search">
          <ChampionSearch 
            onSelectChampion={handleChampionSelect}
            placeholder="Search for a champion..."
          />
        </div>
      )}

      {showDamageCalculatorButton && (
        <div className="header-right">
          <a 
            href="/damage-calculator"
            target="_blank"
            rel="noopener noreferrer"
            className="header-damage-calculator-button"
          >
            ⚔ Sandbox
          </a>
        </div>
      )}
    </div>
  );
};

export default HeaderBar;
